import $ from 'jquery'

class DurationPriceController {
  constructor (ProductUtilsService, $rootScope, $scope) {
    'ngInject'
    this.productUtilsService = ProductUtilsService
    this.showTooltip = false
    this.$rootScope = $rootScope
    $scope.$on('productDurationTooltip:closed', (event, data) => {
      this.showTooltip = false
    })
  }

  $onInit () {
    this.price = this.productUtilsService.getActualPrice(this.product)
    this.item = this.product.group[0]
  }

  onClickCostButton (event) {
    const show = this.showTooltip
    this.$rootScope.$broadcast('productDurationTooltip:closed')
    this.showTooltip = !show
    $('products .product-pages > ul').css('overflow', this.showTooltip ? 'visible' : 'hidden')
  }

  onProductSelected () {
    if (this.selected) {
      this.price = this.selected.price
      this.onDurationChange({item: this.selected})
      this.showTooltip = false
      $('products .product-pages > ul').css('overflow', 'hidden')
    }
  }

  duration (product) {
    return this.productUtilsService.getDuration(product, true)
  }
}

export default DurationPriceController



// WEBPACK FOOTER //
// ./src/app/pages/vehicle/catalog/components/duration-price/duration-price.controller.js